/**
 * NOTE: When updating Programs config, please ensure to also update wiki documentation:
 *       https://confluence.expedia.biz/pages/viewpage.action?pageId=1859099853
 */
export const programs = [
  {
    name: 'us-bex',
    title: 'Expedia USA',
    features: [
      {
        name: 'commission',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    lobs: ['hotel', 'flights', 'package', 'car', 'cruise', 'activities'],
    commissionPercentage: 6,
    cookieDurationDays: 7,
    creativeRef: '',
    signUpLink: 'https://signup.cj.com/member/signup/publisher/?cid=1874913',
    signInLink: 'https://signup.cj.com/member/login/?cid=1874913',
    img: 'https://www.expedia.com/_dms/header/logo.svg',
    brand: 'Expedia',
    posa: 'US',
    siteUrl: 'https://www.expedia.com/?siteid=1&langid=1033',
    displaySiteUrl: 'https://www.expedia.com/',
    locale: 'en_US',
    network: 'CJ',
    // networkTrackingBaseUrl: '',
    live: false,
  },
  {
    name: 'us-expedia',
    title: 'Expedia USA',
    pzName: 'Expedia US',
    features: [
      {
        name: 'commission',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    lobs: ['hotel', 'flights', 'package', 'car', 'cruise', 'activities', 'vacationRentals', 'groundTransfers'],
    commissionPercentage: 6,
    cookieDurationDays: 7,
    creativeRef: '1100l68075',
    signUpLink: '/:localeName/join-program?programName=us-expedia',
    signInLink: null,
    img: 'https://www.expedia.com/_dms/header/logo.svg',
    brand: 'Expedia',
    posa: 'US',
    siteUrl: 'https://www.expedia.com/?siteid=1&langid=1033',
    displaySiteUrl: 'https://www.expedia.com/',
    locale: 'en_US',
    network: 'PARTNERIZE',
    commissionType: 'net_transaction_value',
    networkTrackingBaseUrl: 'https://prf.hn/click',
    live: true,
    visible: false,
    validUrlPattern: '^(https?://)?(www\\.)?expedia\\.com(/.*)?$',
  },
  {
    name: 'us-vrbo',
    pzName: 'Vrbo.com',
    title: 'Vrbo USA',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    lobs: ['vacationRentals'],
    commissionPercentage: 2,
    commissionType: 'net_rental_amount',
    cookieDurationDays: 7,
    creativeRef: '1101l63118',
    signUpLink: '/:localeName/join-program?programName=us-vrbo',
    signInLink: null,
    img: 'https://csvcus.homeaway.com/rsrcs/cdn-logos/5.2.0/sitename/vrbo/web/logo.svg',
    brand: 'Vrbo',
    posa: 'US',
    siteUrl: 'https://www.vrbo.com/?preferlocale=true',
    displaySiteUrl: 'https://www.vrbo.com/',
    locale: 'en_US',
    pzLocale: 'en_us',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://vrbo.prf.hn/click',
    live: true,
    validUrlPattern: '^(https?://)?(www\\.)?vrbo\\.com(?!/\\w{2}-\\w{2})(/.*)?$',
  },
  {
    name: 'uk-vrbo',
    title: 'Vrbo UK',
    pzName: 'Vrbo UK',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    lobs: ['vacationRentals'],
    commissionPercentage: 2,
    commissionType: 'net_rental_amount',
    cookieDurationDays: 7,
    creativeRef: '1011l63085',
    signUpLink: '/:localeName/join-program?programName=uk-vrbo',
    signInLink: null,
    img: 'https://csvcus.homeaway.com/rsrcs/cdn-logos/5.2.0/sitename/vrbo/web/logo.svg',
    brand: 'Vrbo',
    posa: 'GB',
    siteUrl: 'https://www.vrbo.com/en-gb/?preferlocale=true',
    displaySiteUrl: 'https://www.vrbo.com/en-gb/',
    locale: 'en_GB',
    pzLocale: 'en',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://vrbo.prf.hn/click',
    live: true,
    validUrlPattern: '^(https?://)?(www\\.)?vrbo\\.com/en-gb(/.*)?$',
  },
  {
    name: 'au-stayz',
    title: 'Stayz Australia',
    pzName: 'Stayz AU',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    lobs: ['vacationRentals'],
    commissionPercentage: 2,
    commissionType: 'net_rental_amount',
    cookieDurationDays: 7,
    creativeRef: '1011l63086',
    signUpLink: '/:localeName/join-program?programName=au-stayz',
    signInLink: null,
    img: 'http://csvcus.homeaway.com/rsrcs/cdn-logos/5.2.0/sitename/stayz/web/logo.svg',
    brand: 'Stayz',
    posa: 'AU',
    siteUrl: 'https://www.stayz.com.au/',
    locale: 'en_AU',
    pzLocale: 'en',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://vrbo.prf.hn/click',
    live: true,
    validUrlPattern: '^(https?://)?(www\\.)?stayz\\.com\\.au(/.*)?$',
  },
  {
    name: 'ca-vrbo',
    title: 'Vrbo Canada',
    pzName: 'Vrbo Canada',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    lobs: ['vacationRentals'],
    commissionPercentage: 2,
    commissionType: 'net_rental_amount',
    cookieDurationDays: 7,
    creativeRef: '1011l63087',
    signUpLink: '/:localeName/join-program?programName=ca-vrbo',
    signInLink: null,
    img: 'https://csvcus.homeaway.com/rsrcs/cdn-logos/5.2.0/sitename/vrbo/web/logo.svg',
    brand: 'Vrbo',
    posa: 'CA',
    siteUrl: 'https://www.vrbo.com/en-ca?preferlocale=true',
    displaySiteUrl: 'https://www.vrbo.com/en-ca/',
    locale: 'en_CA',
    pzLocale: 'en_ca',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://vrbo.prf.hn/click',
    live: true,
    validUrlPattern: '^(https?://)?(www\\.)?vrbo\\.com/(en-ca|fr-ca)(/.*)?$',
  },
  {
    name: 'fewo-direkt',
    title: 'FeWo-direkt',
    pzName: 'Fewo-Direkt.de',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    lobs: ['vacationRentals'],
    commissionPercentage: 2,
    commissionType: 'net_rental_amount',
    cookieDurationDays: 7,
    creativeRef: '1011l65907',
    signUpLink: '/:localeName/join-program?programName=fewo-direkt',
    signInLink: null,
    img: 'https://csvcus.homeaway.com/rsrcs/cdn-logos/5.2.0/sitename/homeaway_de/web/logo.svg',
    brand: `FeWo-direkt`,
    posa: 'DE',
    siteUrl: 'https://www.fewo-direkt.de/',
    locale: 'de_DE',
    pzLocale: 'de',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://vrbo.prf.hn/click',
    live: true,
    visible: false,
    validUrlPattern: '^(https?://)?(www\\.)?fewo-direkt\\.de(?!/\\w{2}-\\w{2})(/.*)?$',
  },
  {
    name: 'abritel',
    title: 'Abritel',
    pzName: 'Abritel.fr',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    lobs: ['vacationRentals'],
    commissionPercentage: 2,
    commissionType: 'net_rental_amount',
    cookieDurationDays: 7,
    creativeRef: '1101l63119',
    signUpLink: '/:localeName/join-program?programName=abritel',
    signInLink: null,
    img: 'https://csvcus.homeaway.com/rsrcs/cdn-logos/5.2.0/sitename/abritel/web/logo.svg',
    brand: 'Abritel',
    posa: 'FR',
    siteUrl: 'https://www.abritel.fr/',
    locale: 'fr_FR',
    pzLocale: 'fr',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://vrbo.prf.hn/click',
    live: true,
    visible: false,
    validUrlPattern: '^(https?://)?(www\\.)?abritel\\.fr(?!/\\w{2}-\\w{2})(/.*)?$',
  },
  {
    name: 'us-hcom',
    title: 'Hotels.com USA',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    creativeRef: '1011l66481',
    signUpLink: '/:localeName/join-program?programName=us-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'US',
    siteUrl: 'https://www.hotels.com/?pos=HCOM_US&locale=en_US',
    displaySiteUrl: 'https://www.hotels.com/',
    locale: 'en_US',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    commissionPercentage: 4,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 7,
    live: true,
    visible: false,
    validUrlPattern: '^(https?://)?www\\.hotels\\.com(/.*)?$',
  },
  {
    name: 'uk-hcom',
    title: 'Hotels.com UK',
    creativeRef: '1011l66932',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    signUpLink: '/:localeName/join-program?programName=uk-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'GB',
    siteUrl: 'https://uk.hotels.com/?pos=HCOM_UK&locale=en_GB',
    displaySiteUrl: 'https://uk.hotels.com/',
    locale: 'en_GB',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    commissionPercentage: 3,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 30,
    live: true,
    visible: false,
    validUrlPattern: '^(https?://)?uk\\.hotels\\.com(/.*)?$',
  },
  {
    name: 'ca-hcom',
    title: 'Hotels.com Canada',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    creativeRef: '1101l67721',
    signUpLink: '/:localeName/join-program?programName=ca-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'CA',
    siteUrl: 'https://ca.hotels.com/?pos=HCOM_CA&locale=en_CA',
    displaySiteUrl: 'https://ca.hotels.com/',
    locale: 'en_CA',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    commissionPercentage: 4,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 7,
    live: true,
    visible: false,
    validUrlPattern: '^(https?://)?ca\\.hotels\\.com(/.*)?$',
  },
  {
    name: 'au-hcom',
    title: 'Hotels.com Australia',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    creativeRef: '1101l67722',
    signUpLink: '/:localeName/join-program?programName=au-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'AU',
    siteUrl: 'https://au.hotels.com/?pos=HCOM_AU&locale=en_AU',
    displaySiteUrl: 'https://au.hotels.com/',
    locale: 'en_AU',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    commissionPercentage: 3,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 30,
    live: true,
    visible: false,
    validUrlPattern: '^(https?://)?au\\.hotels\\.com(/.*)?$',
  },
  {
    name: 'fr-hcom',
    title: 'Hotels.com France',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    creativeRef: '',
    signUpLink: '/:localeName/join-program?programName=fr-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'FR',
    siteUrl: 'https://fr.hotels.com/?pos=HCOM_FR&locale=fr_FR',
    displaySiteUrl: 'https://fr.hotels.com/',
    locale: 'fr_FR',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    // no info yet
    commissionPercentage: 0,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 7,
    live: false,
    visible: false,
    validUrlPattern: '^(https?://)?fr\\.hotels\\.com(/.*)?$',
  },
  {
    name: 'de-hcom',
    title: 'Hotels.com Deutschland',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    creativeRef: '',
    signUpLink: '/:localeName/join-program?programName=de-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'DE',
    siteUrl: 'https://de.hotels.com/?pos=HCOM_DE&locale=de_DE',
    displaySiteUrl: 'https://de.hotels.com/',
    locale: 'de_DE',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    commissionPercentage: 3,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 30,
    live: false,
    visible: false,
    validUrlPattern: '^(https?://)?de\\.hotels\\.com(/.*)?$',
  },
  {
    name: 'dk-hcom',
    title: 'Hotels.com Danmark',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    creativeRef: '',
    signUpLink: '/:localeName/join-program?programName=dk-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'DK',
    siteUrl: 'https://da.hotels.com/?pos=HCOM_DK&locale=da_DK',
    displaySiteUrl: 'https://da.hotels.com/',
    locale: 'da_DK',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    commissionPercentage: 4,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 30,
    live: false,
    visible: false,
    validUrlPattern: '^(https?://)?da\\.hotels\\.com(/.*)?$',
  },
  {
    name: 'fi-hcom',
    title: 'Hotels.com Suomi',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    creativeRef: '',
    signUpLink: '/:localeName/join-program?programName=fi-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'FI',
    siteUrl: 'https://fi.hotels.com/?pos=HCOM_FI&locale=fi_FI',
    displaySiteUrl: 'https://fi.hotels.com/',
    locale: 'fi_FI',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    commissionPercentage: 4,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 30,
    live: false,
    visible: false,
    validUrlPattern: '^(https?://)?fi\\.hotels\\.com(/.*)?$',
  },
  {
    name: 'no-hcom',
    title: 'Hotels.com Norge',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    creativeRef: '',
    signUpLink: '/:localeName/join-program?programName=no-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'NO',
    siteUrl: 'https://no.hotels.com/?pos=HCOM_NO&locale=no_NO',
    displaySiteUrl: 'https://no.hotels.com/',
    locale: 'nb_NO',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    commissionPercentage: 4,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 30,
    live: false,
    visible: false,
    validUrlPattern: '^(https?://)?no\\.hotels\\.com(/.*)?$',
  },
  {
    name: 'se-hcom',
    title: 'Hotels.com Sverige',
    features: [
      {
        name: 'commission',
        hasTooltip: true,
        tooltipDialogPrefix: 'commercialRules',
      },
      {
        name: 'cookies',
        hasTooltip: false,
        tooltipDialogPrefix: '',
      },
    ],
    creativeRef: '',
    signUpLink: '/:localeName/join-program?programName=se-hcom',
    signInLink: null,
    img: 'https://s27.q4cdn.com/708721433/files/images/2020/travel-with-us-hotels-logo.png',
    brand: 'Hcom',
    posa: 'SE',
    siteUrl: 'https://sv.hotels.com/?pos=HCOM_SE&locale=sv_SE',
    displaySiteUrl: 'https://sv.hotels.com/',
    locale: 'sv_SE',
    network: 'PARTNERIZE',
    networkTrackingBaseUrl: 'https://hotels.prf.hn/click',
    lobs: ['hotel', 'vacationRentals'],
    commissionPercentage: 4,
    commissionType: 'net_transaction_value',
    cookieDurationDays: 30,
    live: false,
    visible: false,
    validUrlPattern: '^(https?://)?sv\\.hotels\\.com(/.*)?$',
  },
];
